/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { CelebrationGiftBoxIcon16Light } from './CelebrationGiftBoxIcon16Light';
import { CelebrationGiftBoxIcon16Regular } from './CelebrationGiftBoxIcon16Regular';
import { CelebrationGiftBoxIcon16Solid } from './CelebrationGiftBoxIcon16Solid';
import { CelebrationGiftBoxIcon20Light } from './CelebrationGiftBoxIcon20Light';
import { CelebrationGiftBoxIcon20Regular } from './CelebrationGiftBoxIcon20Regular';
import { CelebrationGiftBoxIcon20Solid } from './CelebrationGiftBoxIcon20Solid';
import { CelebrationGiftBoxIcon24Regular } from './CelebrationGiftBoxIcon24Regular';
import { CelebrationGiftBoxIcon24Solid } from './CelebrationGiftBoxIcon24Solid';
import { CelebrationGiftBoxIcon32Regular } from './CelebrationGiftBoxIcon32Regular';
import { CelebrationGiftBoxIcon64Regular } from './CelebrationGiftBoxIcon64Regular';
var sizes = {
    16: {
        light: CelebrationGiftBoxIcon16Light,
        regular: CelebrationGiftBoxIcon16Regular,
        solid: CelebrationGiftBoxIcon16Solid,
    },
    20: {
        light: CelebrationGiftBoxIcon20Light,
        regular: CelebrationGiftBoxIcon20Regular,
        solid: CelebrationGiftBoxIcon20Solid,
    },
    24: {
        regular: CelebrationGiftBoxIcon24Regular,
        solid: CelebrationGiftBoxIcon24Solid,
    },
    32: {
        regular: CelebrationGiftBoxIcon32Regular,
    },
    64: {
        regular: CelebrationGiftBoxIcon64Regular,
    },
};
export var CelebrationGiftBoxIcon = forwardRef('CelebrationGiftBoxIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
